if (!customElements.get('quick-order-list')) {
    customElements.define(
        'quick-order-list',
        class QuickOrderList extends BulkAdd {
            constructor() {
                super();

                this.adding = false
                this.$allAddToCarts = document.querySelectorAll("button[name='allAddToCart']");
                this.$updates = document.querySelectorAll("input[name='updates[]']");
                this.$totalQuantity = document.getElementById("totalQuantity");
                this.$totalAmount = document.getElementById("totalAmount");
                this.isReserved = this.dataset.isReserved === 'true';
                this.initQuantityInputs();
                this.initAllAddToCarts();
            }

            updateVariantAmount(variantId, quantity, price) {
                const amount = price * quantity * 0.01;
                const $price = document.getElementById('Price-' + variantId);
                if ($price) {
                    if (amount > 0) {
                        $price.textContent = "¥" + amount.toLocaleString();
                    } else {
                        $price.textContent = "¥0";
                    }
                }
            }

            updateAmount() {
                let count = 0;
                let amount = 0;

                this.$updates.forEach(function ($update) {
                    const quantity = parseInt($update.value);
                    if (!isNaN(quantity)) {
                        count += quantity;
                    }

                    const price = parseInt($update.dataset.price);
                    if (!isNaN(price)) {
                        amount += price * quantity * 0.01;
                    }
                });

                if (count > 0) {
                    this.$totalQuantity.textContent = count;
                }

                if (amount > 0) {
                    this.$totalAmount.textContent = "¥" + amount.toLocaleString();
                }
            }

            initQuantityInputs() {
                this.$updates.forEach(($update) => {
                    $update.addEventListener('change', async (event) => {
                        event.preventDefault();

                        const variantId = $update.dataset.quantityVariantId;
                        const variantJson = getVariantJson(variantId);

                        const max = parseInt($update.dataset.max);
                        let quantity = parseInt($update.value);

                        if(quantity > max) {
                            quantity = max;
                            $update.value = max;
                        }

                        if (quantity > 0 && variantJson != null) {
                            const validate = await checkAddable(variantJson.productId, this.isReserved);

                            if (!validate) {
                                alert(alertMessages.reservationRestriction);
                                $update.value = 0;
                                return;
                            }
                        }

                        this.updateVariantAmount(variantId, quantity, variantJson.price);
                        this.updateAmount();
                    });
                });
            }

            initAllAddToCarts() {
                this.$allAddToCarts.forEach(($allAddToCart) => {
                    $allAddToCart.addEventListener('click', (event) => {
                        event.preventDefault();
                        if (this.adding) {
                            return;
                        }
                        this.adding = true;

                        const items = [];
                        let properties = {}
                        if (this.isReserved) {
                            properties = {
                                "発注区分": "FOなど受注品"
                            }
                        }

                        this.$updates.forEach(function ($update) {
                            const variantId = $update.dataset.quantityVariantId;
                            const quantity = parseInt($update.value);

                            if (quantity > 0) {
                                items.push(
                                    {
                                        id: variantId,
                                        quantity: quantity,
                                        properties
                                    }
                                );
                            }
                        });

                        if (items.length) {
                            const body = JSON.stringify({items});

                            $allAddToCart.querySelector('.quick-adding__list-buttons .loading__spinner')?.classList.remove('hidden');
                            $allAddToCart.querySelector('.quick-adding__list-buttons .quick-order-list__button-text')?.classList.add('hidden');

                            fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{body}})
                                .then((response) => {
                                    return response.text();
                                })
                                .then((state) => {
                                    this.resetForm($allAddToCart);

                                    const parsedState = JSON.parse(state);
                                    if(parsedState && parsedState.errors) {
                                        alert(parsedState.errors);
                                        window.location.reload();
                                    } else {
                                        window.location.href = routes.cart_url;
                                    }
                                })
                                .catch(() => {
                                    alert(window.cartStrings.error);
                                    this.resetForm($allAddToCart);
                                });
                        } else {
                            this.adding = false;
                        }
                    });

                });
            }

            resetForm($allAddToCart) {
                this.$updates.forEach(function ($update) {
                    $update.value = 0;
                });

                this.$totalQuantity.textContent = "0";
                this.$totalAmount.textContent = "¥0";

                $allAddToCart.querySelector('.quick-adding__list-buttons .loading__spinner')?.classList.add('hidden');
                $allAddToCart.querySelector('.quick-adding__list-buttons .quick-order-list__button-text')?.classList.remove('hidden');

                this.adding = false;
            }
        }
    );
}
